// Online Store ID - Indication that application is on server side
export const ONLINE_STORE_ID = '8119';
export const B2B = 'b2b';

export const LISTS_CRUMB = {
  label: 'Lists',
  url: '/list/view/summary',
};
export const ACCOUNT_DASHBOARD = '/myaccount/dashboard';
